<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="uniqueId"
        slim
        v-slot="{ validated, valid, errors }"
    >
        <rkm-form-group
            :invalid-feedback="errors[0]"
            :label="label + (validations && validations.required ? ' *' : '')"
            :state="rules ? (disabled ? null : (validated ? valid : null)) : null"
        >
            <b-form-textarea
                :disabled="disabled"
                :formatter="formatter"
                :max-rows="maxRows"
                :maxlength="maxlength"
                :placeholder="placeholder"
                :readonly="readonly"
                :required="required"
                :rows="rows"
                :size="size"
                :state="rules ? (validated ? valid ? null : false : null) : null"
                :value="value"
                @blur="$emit('blur', $event)"
                @click="$emit('change', $event)"
                @input="$emit('input', $event)"
                @update="$emit('update', $event)"
            />
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
import {BFormTextarea} from 'bootstrap-vue'
import {ValidationProvider} from 'vee-validate';

export default {
    components: { BFormTextarea, ValidationProvider },
    computed: {
        rules() {
            return this.disabled ? null : this.validations
        },
    },
    props: {
        description: {type: String},
        disabled: {type: Boolean},
        formatter: {type: Function},
        label: {type: String},
        large: {type: Boolean, default: false},
        maxRows: {type: [Number, String]},
        maxlength: {type: [Number, String], required: false},
        name: {type: String},
        placeholder: {type: String},
        readonly: {type: Boolean, default: false},
        required: {type: Boolean, default: false},
        rows: {type: [Number, String], default: 2},
        small: {type: Boolean, default: false},
        state: {type: Boolean, default: null},
        type: {type: String, default: 'text'},
        validationMode: {type: String, default: 'lazy'},
        validations: {type: Object, default: null},
        value: {type: [Number, String]},
    }
}
</script>